import { QuestionOptionDescription as Question } from "@/components/features/items/edit/option/_shared/ui/components/description/description";

import { useOptionI18nDescription } from "./hooks";

export const QuestionOptionI18nDescription = () => {
	const { description, onSetDescription } = useOptionI18nDescription();

	return <Question description={description} onSetDescription={onSetDescription} />;
};

QuestionOptionI18nDescription.displayName = "QuestionOptionI18nDescription";
